module.exports = __webpack_public_path__ + "assets/img/e092-td.svg";